import { render, staticRenderFns } from "./Software.vue?vue&type=template&id=2fd2a37f&scoped=true&"
import script from "./Software.vue?vue&type=script&lang=js&"
export * from "./Software.vue?vue&type=script&lang=js&"
import style0 from "./Software.vue?vue&type=style&index=0&id=2fd2a37f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd2a37f",
  null
  
)

export default component.exports